import React, { useState, useEffect } from "react";
import GoogleLogin from "react-google-login";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
// Removed Spinner import; using inline loading animation instead

const verticalLines = [
  { marginTop: "mt-[35.9px]", marginLeft: "ml-[-0.9px]" },
  { marginTop: "mt-[30.1px]", marginLeft: "ml-[16.9px]" },
  { marginTop: "mt-0", marginLeft: "ml-[16.0px]" },
  { marginTop: "mt-[28.2px]", marginLeft: "ml-[16.9px]" },
  { marginTop: "mt-[33.0px]", marginLeft: "ml-[15.1px]" },
  { marginTop: "mt-[23.4px]", marginLeft: "ml-[16.0px]" },
];

const rightVerticalLines = [
  {
    marginTop: "mt-0",
    marginLeft: "ml-[-0.9px]",
    height: "h-[87.95px]",
    src: "/line-439.svg",
  },
  {
    marginTop: "mt-[8.4px]",
    marginLeft: "ml-[17px]",
    height: "h-[118.14px]",
    src: "/line-440-1.svg",
  },
  {
    marginTop: "mt-[10.9px]",
    marginLeft: "ml-[16.0px]",
    height: "h-[87.95px]",
    src: "/line-439.svg",
  },
  {
    marginTop: "mt-[4.1px]",
    marginLeft: "ml-[16.9px]",
    height: "h-[87.95px]",
    src: "/line-439.svg",
  },
  {
    marginTop: "mt-[5.0px]",
    marginLeft: "ml-[15.1px]",
    height: "h-[116.46px]",
    src: "/line-437-2.svg",
  },
  {
    marginTop: "mt-[0.7px]",
    marginLeft: "ml-[16.1px]",
    height: "h-[87.95px]",
    src: "/line-439.svg",
  },
];

const farRightLines = [
  {
    marginTop: "mt-[27.5px]",
    marginLeft: "ml-[-0.9px]",
    height: "h-[87.95px]",
    src: "/line-439.svg",
  },
  {
    marginTop: "",
    marginLeft: "ml-[17px]",
    height: "h-[154px]",
    src: "/line-440-2.svg",
  },
  {
    marginTop: "mt-[3px]",
    marginLeft: "ml-4",
    height: "h-[123px]",
    src: "/line-439-1.svg",
  },
  {
    marginTop: "mt-[31.6px]",
    marginLeft: "ml-[16.9px]",
    height: "h-[87.95px]",
    src: "/line-439.svg",
  },
];

const pills = [
  { id: 1, label: "Digital Marketer", top: 29, left: 20, width: 116 },
  { id: 2, label: "Data Scientist", top: 68, left: 157, width: 105 },
  { id: 3, label: "Cybersecurity Engineer", top: 109, left: 53, width: 159 },
];

export const ReadyToJoin = ({ authResponse }) => {
  const [currentArrowPosition, setCurrentArrowPosition] = useState(0);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const isDesktop = window.innerWidth >= 1024

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentArrowPosition((prev) => (prev + 1) % 3);
    }, 2000); // Change position every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mt-11 md:mt-[90px] md:relative flex w-full flex-col md:flex-row md:justify-between items-center gap-4 overflow-hidden rounded-2xl border border-solid border-transparent  px-3 pt-0 pb-3 md:p-10 md:gap-10 " style={
      isDesktop
        ? {
            backgroundImage:
              "url('https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Desktop/Frame%2059.webp')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100%",
          }
        : {background: `linear-gradient(to top, rgba(11, 29, 43, 0), #0B1D2B), rgba(66, 133, 244, 0.15)`} // no background on mobile
    }>

    <div className="w-[85%] md:flex-1 md:h-[255px] md:rounded-[24px] md:px-8 md:py-6 md:overflow-hidden"  style={isDesktop ? {background: `linear-gradient(to top, rgba(11, 29, 43, 0), #0B1D2B), rgba(66, 133, 244, 0.15)`} : {}} >
      <div className="relative w-full h-full ">
        <img
          src="https://assets.learntube.ai/files/Academy%20course%20detail/Group%2023572.png"
          className="h-auto w-full "
          alt=""
        />

        {/* Logo 1 */}
        <div
          className={`absolute -left-[2%] bottom-[10%] transition-all duration-1000 ease-in-out`}
        >
          <div className="relative flex items-center justify-start">
            <img
              className="h-[30px] w-[30px] md:h-[40px] md:w-[40px]"
              width={30}
              height={30}
              src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/ReadyToJoin/Frame%20427321765%20(1).png"
              alt=""
            />
            {/* <div className={`${currentArrowPosition === 0 ? 'bg-[#406AFF]/40' : 'bg-[#406AFF26]'} rounded-[24px] px-3 py-[6px] text-[12px] -ml-2 font-medium backdrop-blur-[10px] relative`}>
                      {Array.isArray(pills) && pills?.[0]?.label}
                      {currentArrowPosition === 0 && (
                        <img
                          src="https://assets.learntube.ai/files/Academy%20course%20detail/fluent_cursor-16-filled.png"
                          width={18}
                          height={18}
                          className="absolute right-1 -bottom-2 animate-pulse transition-all duration-500 ease-in-out opacity-100 transform scale-100"
                          alt=""
                        />
                      )}
                    </div> */}
          </div>
        </div>

        {/* Logo 2 */}
        <div
          className={`absolute left-[5%] top-[20%] transition-all duration-1000 ease-in-out`}
        >
          <div className="relative flex flex-col items-center">
            <div
              className={`${
                currentArrowPosition === 0
                  ? "bg-[#406AFF]/40"
                  : "bg-[#406AFF26]"
              } relative -mb-1 whitespace-nowrap rounded-[24px] px-3 py-[6px] text-[12px] md:text-[16px] font-medium text-white backdrop-blur-[10px]`}
            >
              {Array.isArray(pills) && pills?.[0]?.label}{" "}
              {currentArrowPosition === 0 && (
                <img
                  src="https://assets.learntube.ai/files/Academy%20course%20detail/fluent_cursor-16-filled.png"
                  width={18}
                  height={18}
                  alt=""
                  className="absolute right-1 -bottom-2 scale-100 transform animate-pulse opacity-100 transition-all duration-500 ease-in-out"
                />
              )}
            </div>
            <img
              className="mt-2 h-[30px] w-[30px] md:h-[40px] md:w-[40px]"
              width={30}
              height={30}
              src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/ReadyToJoin/Frame%2023225.png"
              alt="-mr-4"
            />
          </div>
        </div>

        {/* Logo 3 */}
        <div
          className={`absolute left-[50%] bottom-[2%] transition-all duration-1000 ease-in-out`}
        >
          <div className="relative flex w-full flex-col items-end justify-center">
            <div
              className={`${
                currentArrowPosition === 1
                  ? "bg-[#406AFF]/40"
                  : "bg-[#406AFF26]"
              } absolute z-10 -mt-4 ml-4 rounded-[24px] px-3 py-[6px] text-[12px] md:text-[16px] font-medium backdrop-blur-[10px] `}
            >
              <p className="max-w-[100px] overflow-hidden text-ellipsis  whitespace-nowrap font-medium text-white md:max-w-[120px]">
                {Array.isArray(pills) && pills?.[1]?.label}
              </p>
              {currentArrowPosition === 1 && (
                <img
                  src="https://assets.learntube.ai/files/Academy%20course%20detail/fluent_cursor-16-filled.png"
                  width={18}
                  height={18}
                  className="absolute right-0 -bottom-2 z-20 scale-100 transform animate-pulse opacity-100 transition-all duration-500 ease-in-out"
                  alt=""
                />
              )}
            </div>
            <img
              className="mt-8 h-[30px] w-[30px] md:h-[40px] md:w-[40px] "
              width={30}
              height={30}
              src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/ReadyToJoin/Frame%2023225%20(1).png"
              alt=""
            />
          </div>
        </div>

        {/* Logo 4 */}
        <div
          className={`absolute left-[50%] -top-[10%] transition-all duration-1000 ease-in-out`}
        >
          <div className="relative flex w-full flex-col items-end justify-center">
            <img
              className="mt-8 h-[30px] w-[30px] md:h-[40px] md:w-[40px] "
              width={30}
              height={30}
              src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/ReadyToJoin/Frame%20427321764%20(1).png"
              alt=""
            />
          </div>
        </div>

        {/* Logo 5 */}
        <div
          className={`absolute left-[90%] bottom-[40%] transition-all duration-1000 ease-in-out`}
        >
          <div className="relative flex w-full flex-col items-end justify-center">
            <img
              className="h-[30px] w-[30px] md:h-[40px] md:w-[40px]  flex-shrink-0"
              width={30}
              height={30}
              src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/ReadyToJoin/Frame%20427321766.png"
              alt=""
            />
            <div
              className={`${
                currentArrowPosition === 2
                  ? "bg-[#406AFF]/40"
                  : "bg-[#406AFF26]"
              } absolute z-10 -mt-4 ml-4 mr-2 mb-4 rounded-[24px] px-3 py-[6px] text-[12px]  md:text-[16px] font-medium backdrop-blur-[10px]`}
            >
              <p className="max-w-[100px] overflow-hidden text-ellipsis  whitespace-nowrap text-white md:max-w-[120px]">
                {Array.isArray(pills) && pills?.[2]?.label}
              </p>
              {currentArrowPosition === 2 && (
                <img
                  src="https://assets.learntube.ai/files/Academy%20course%20detail/fluent_cursor-16-filled.png"
                  width={18}
                  height={18}
                  className="absolute right-0 -bottom-2 z-20 scale-100 transform animate-pulse opacity-100 transition-all duration-500 ease-in-out"
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

      <div className="w-full md:flex-1 md:flex-shrink-0 flex flex-col items-center justify-center" >      
        <div className="w-full text-center text-[20px] md:text-[32px] md:text-left font-semibold leading-[130%] text-white text-white text-transparent" style={{
      background: "linear-gradient(to right, #FFFFFF 0%, #F7E394 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    
    }}>
          Ready To Join learners who Are Already Transforming Their Careers?
        </div>

        <GoogleLogin
          clientId={XANO_GOOGLE_CLIENT_ID}
          render={(renderProps) => {
            return (
              <div
                className="mt-4 md:mt-4 w-full z-100 rounded-lg h-12 px-[2px] pb-[2px] shadow-[0px_0px_10px_#7fc24159] hover:bg-[#7fc241] hover:opacity-90"
                style={{
                  background:
                    "linear-gradient(to right, #8BD845 0%, #C5E2AB 100%)",
                }}
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
              >
                {false ? (
                  <button className="flex w-full  h-full w-full items-center justify-center gap-2.5 self-stretch rounded-lg bg-[#7fc241] py-auto ">
                    <div className="flex items-center justify-center gap-2 ">
                      <span className="h-3 w-3 rounded-full bg-light_green animate-bigbounce [animation-delay:0ms]"></span>
                      <span className="h-3 w-3 rounded-full bg-light_green animate-bigbounce [animation-delay:150ms]"></span>
                      <span className="h-3 w-3 rounded-full bg-light_green animate-bigbounce [animation-delay:300ms]"></span>
                    </div>
                  </button>
                ) : (
                  <button className="flex w-full  w-full items-center justify-center gap-2.5 self-stretch rounded-lg bg-[#7fc241] py-3 ">
                    <span className="w-fill relative flex w-fit items-center justify-center text-center text-center text-lg md:text-[18px] font-semibold leading-[normal] tracking-[0] text-[#121212] [font-family:'Inter',Helvetica]">
                      Start Your Free Journey Now!
                    </span>
                  </button>
                )}
              </div>
            );
          }}
          onSuccess={(e)=> authResponse(e , setIsGoogleLoading)}
          onFailure={(e)=> authResponse(e , setIsGoogleLoading)}
          cookiePolicy={"single_host_origin"}
        />
      </div>  
      
    </div>
  );
};
